import { render } from "./TripAllDetailsPage.vue?vue&type=template&id=a10e97d2&scoped=true"
import script from "./TripAllDetailsPage.vue?vue&type=script&lang=ts"
export * from "./TripAllDetailsPage.vue?vue&type=script&lang=ts"

import "./TripAllDetailsPage.vue?vue&type=style&index=0&id=a10e97d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a10e97d2"

export default script